import React from 'react'

import Select, {SelectableItem} from 'airship/patterns/select'
import {getCurrentUrl} from 'airship/utils/region-urls'

import {RegionItems} from './constants'

export interface Props {
  onSelect: (id: SelectableItem<string>['id']) => void
  displayClasses?: string
}

const RegionSelect: React.FC<Props> = ({onSelect, displayClasses}) => {
  return (
    <Select
      menuLabel="Select a region/country"
      items={RegionItems}
      onSelect={(value) => value && onSelect(value)} // Prevent triggering onSelect with empty value
      selected={getCurrentUrl()}
      displayClasses={displayClasses}
    />
  )
}

export default RegionSelect
